import { gql } from '@apollo/client';

export const SEND_MESSAGE = gql`
  mutation sendMessage($message_input: SendMessageInput!) {
    sendMessage(message_input: $message_input) {
      success
      message
    }
  }
`;

export const SEND_SMS_TEXT_MESSAGE = gql`
  mutation sendSmsTextMessage($message_input: SendSmsTextMessageInput!) {
    sendSmsTextMessage(message_input: $message_input) {
      success
    }
  }
`;

export const SAVE_SMS_TEXT = gql`
  mutation SaveSmsText($text: String!) {
    SaveSmsText(text: $text) {
      success
      message
    }
  }
`;

export const CREATE_SMS_ACCOUNT = gql`
  mutation createSmsAccount {
    createSmsAccount {
      success
      message
    }
  }
`;

export const GET_OPENAI_COMPLETION_DIRECT_MUTATION = gql`
  mutation getOpenAiCompletionDirect(
    $prompt: String!
    $top_p: Float!
    $stop: [String!]
    $company_idx: Int!
    $userTopicId: Int
    $userType: Int
    $topic: String
    $showImage: Boolean
    $data: String
    $external_user_study_idx: Int
    $messagesIds: [Int!]
    $open_ai_message: String
    $messages: String
    $asDefault: Boolean
    $file_url: String
  ) {
    getOpenAiCompletionDirect(
      prompt: $prompt
      top_p: $top_p
      stop: $stop
      company_idx: $company_idx
      userTopicId: $userTopicId
      userType: $userType
      topic: $topic
      showImage: $showImage
      data: $data
      external_user_study_idx: $external_user_study_idx
      messagesIds: $messagesIds
      open_ai_message: $open_ai_message
      messages: $messages
      asDefault: $asDefault
      file_url: $file_url
    )
  }
`;

export const GET_OPENAI_COMPLETION_STRUCTURED_OUTPUT_MUTATION = gql`
  mutation getOpenAiCompletionDirectStructured(
    $prompt: String!
    $top_p: Float!
    $stop: [String!]
    $company_idx: Int!
    $userTopicId: Int
    $userType: Int
    $topic: String
    $showImage: Boolean
    $data: String
    $external_user_study_idx: Int
    $messagesIds: [Int!]
    $open_ai_message: String
    $messages: String
    $asDefault: Boolean
    $file_url: String
    $structured_output: JSONObject!
    $reasoning_effort: String = "low"
  ) {
    getOpenAiCompletionDirectStructured(
      prompt: $prompt
      top_p: $top_p
      stop: $stop
      company_idx: $company_idx
      userTopicId: $userTopicId
      userType: $userType
      topic: $topic
      showImage: $showImage
      data: $data
      external_user_study_idx: $external_user_study_idx
      messagesIds: $messagesIds
      open_ai_message: $open_ai_message
      messages: $messages
      asDefault: $asDefault
      file_url: $file_url
      structured_output: $structured_output
      reasoning_effort: $reasoning_effort
    )
  }
`;

export const GET_OPENAI_COMPLETION_STRUCTURED_FROM_MESSAGES_MUTATION = gql`
  mutation getOpenAiCompletionDirectStructuredFromMessages(
    $developer_instruction: String!
    $user_messages: [String!]!
    $structured_output: JSONObject!
    $company_idx: Int!
    $reasoning_effort: String
    $data: String
    $open_ai_message: String
    $asDefault: Boolean = false
    $top_p: Float = 1
    $stop: [String!]
  ) {
    getOpenAiCompletionDirectStructuredFromMessages(
      developer_instruction: $developer_instruction
      user_messages: $user_messages
      structured_output: $structured_output
      company_idx: $company_idx
      reasoning_effort: $reasoning_effort
      data: $data
      open_ai_message: $open_ai_message
      asDefault: $asDefault
      top_p: $top_p
      stop: $stop
    )
  }
`;
